<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <v-text-field
            v-model="filter"
            outlined
            placeholder="PESQUISAR PELO NOME DO MEDICAMENTO"
            @input="get"
          />
        </div>
        <div class="col-md-12">
          <ErrorsMessages :errors="errors" />
          <div v-if="medicines.length == 0" class="text-center">
            <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
          </div>
          <table v-if="medicines.length > 0" class="table">
            <tbody>
              <tr v-for="(medicine, key) in medicines" :key="key">
                <td style="width: 50% !important">
                  <div>
                    <small>CÓDIGO: {{ medicine.id }}</small>
                    <br />
                    <small>NOME: {{ medicine.name }}</small>
                    <br />
                    <small>APRESENTAÇÃO: {{ medicine.presentation }}</small>
                    <br />
                    <small
                      >CLASSE TERAPÊUTICA: {{ medicine.therapeutic_class }}
                    </small>
                    <br />
                    <small
                      >UNIDADE DE MEDIDA:
                      {{ medicine.unit_of_measurement_name }}
                    </small>
                    <br />
                    <small
                      >PRINCÍPIO ATIVO:
                      <span class="c-danger">{{
                        medicine.active_ingredient_name
                      }}</span>
                    </small>
                    <br />
                    <small
                      >TIPO DE RECEITA:
                      {{ medicine.type_of_recipe_name }}</small
                    >
                    <br />
                  </div>
                </td>
                <td style="width: 50% !important">
                  <div class="row">
                    <div
                      v-if="medicine.medicines.length == 0"
                      class="col-md-12 c-danger"
                    >
                      NENHUM MEDICAMENTO PARECIDO ENCONTRADO
                    </div>
                    <div
                      v-if="medicine.medicines.length > 0"
                      class="col-md-12 c-warning"
                    >
                      MEDICAMENTOS PARECIDOS
                    </div>
                    <div
                      class="col-md-12 border"
                      v-for="(item, index) in medicine.medicines"
                      :key="index"
                    >
                      <small>CÓDIGO: {{ item.id }} </small>
                      <br />
                      <small>NOME: {{ item.name }} </small>
                      <br />
                      <small>APRESENTAÇÃO: {{ item.presentation }} </small>
                      <br />
                      <small
                        >CLASSE TERAPÊUTICA: {{ item.therapeutic_class }}
                      </small>
                      <br />
                      <small
                        >UNIDADE DE MEDIDA:
                        {{ item.unit_of_measurement_name }}
                      </small>
                      <br />
                      <small
                        >PRINCÍPIO ATIVO:
                        <span class="c-danger">{{
                          item.active_ingredient_name
                        }}</span>
                      </small>
                      <br />
                      <small
                        >TIPO DE RECEITA: {{ item.type_of_recipe_name }}</small
                      >
                      <br />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <errors-messages :errors="errors" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import NavBar from "../templates/NavBar";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "VerifyMedicines",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },
  data() {
    return {
      filter: "",
      medicines: [],
      errors: [],
    };
  },
  methods: {
    async get() {
      try {
        const response = await api.get("/release/verify-medicines", {
          params: {
            filter: this.filter,
          },
        });

        const { error, errors, all } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicines = all;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteMedicine(id) {
      try {
        let data = { id };

        const response = await api.delete(
          "/rest-home/medicine/delete-by-verify-medicines",
          {
            data,
          }
        );

        const { error, errors } = response.data;

        if (!error) {
          this.get();
          toast("MEDICAMENTO DELETADO COM SUCESSO", "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
